// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3_3-y","detailsBorder":"styles_detailsBorder__mUDbv"};